import { type FC, useCallback, useEffect } from "react";

import { Modal, type ModalProps } from "@snapchat/snap-design-system";

import { KeyboardKey } from "../model";

type ActionModalProps = {
    shouldAddKeyEvent?: boolean;
} & ModalProps;

const ActionModal: FC<ActionModalProps> = ({
    shouldAddKeyEvent = true,
    visible,
    onAction,
    children,
    ...modalProps
}) => {
    const onKeyPress = useCallback(
        (e: KeyboardEvent) => {
            if ((e.key as KeyboardKey) === KeyboardKey.Enter) {
                onAction?.();
            }
        },
        [onAction],
    );

    useEffect(() => {
        if (visible && shouldAddKeyEvent) {
            document.addEventListener("keydown", onKeyPress);
        } else {
            document.removeEventListener("keydown", onKeyPress);
        }

        return () => {
            document.removeEventListener("keydown", onKeyPress);
        };
    }, [visible, onKeyPress, shouldAddKeyEvent]);

    return (
        <Modal {...modalProps} visible={visible} onAction={onAction}>
            {children}
        </Modal>
    );
};

export { ActionModal };
